import { SubjectRoles } from "@/api-schema-enums";
import { isDevStage } from "@/config/configuration";

export function hasDevStageDeveloperAccess(roles: readonly SubjectRoles[] = []): boolean {
  return isDevStage && roles.includes(SubjectRoles.Developer);
}
